import React from 'react';
import VisibilitySensor from "react-visibility-sensor";
import cell11 from "../../../assets/images/home/cell-1/1.png";
import cell12 from "../../../assets/images/home/cell-1/2.svg";
import cell13 from "../../../assets/images/home/cell-1/3.svg";
import cell14 from "../../../assets/images/home/cell-1/4.svg";

let thisComponent;

class Hero extends React.Component {

	constructor(props) {
	  super(props);
	  this.state = {
		  isVisible: null
	  };
	};

	componentWillMount() {
		thisComponent = this;
	}

	onVisibilityChange(isVisible) {
		if (isVisible) { // Solamente cambia visibilidad a TRUE
			thisComponent.setState({isVisible})
		}
	}
	  
	render() {
		return (
			<VisibilitySensor
				onChange={this.onVisibilityChange}
			>
				<section className={`hero ${this.state.isVisible ? "-visible" : "-hidden"}`}>
					<div className="hero__wrapper container">
						<div className="row">
							<div className="hero__info col">
								<h1 className="hero__title">Nuestro objetivo es elevar los estándares de calidad y precisión en análisis clínicos.</h1>
							</div>
							<div className="hero__cell col">
								<img src={cell11} alt="" className="hero__cell__image hero__cell__image--1"/>
								<img src={cell12} alt="" className="hero__cell__image hero__cell__image--2"/>
								<img src={cell13} alt="" className="hero__cell__image hero__cell__image--3"/>
								<img src={cell14} alt="" className="hero__cell__image hero__cell__image--4"/>
							</div>
						</div>
					</div>
				</section>
			</VisibilitySensor>
		)
	}
};

export default Hero;
